module.exports = __webpack_public_path__ + "img/price.ce2440da.png";